
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/articles/challenges-in-machine-data-collection",
      function () {
        return require("private-next-pages/[locale]/articles/challenges-in-machine-data-collection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/articles/challenges-in-machine-data-collection"])
      });
    }
  